import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {AbstractDataServiceV2} from 'src/app/modules/core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from 'src/app/store/core/url/customizeHttpUrlGenerator';
import {SaleModel} from '../../../api/entity/sale.model';
import {SaleConverter} from '../../../api/entity/converter/sale.converter';


@Injectable({providedIn: 'root'})
export class SaleDataService extends AbstractDataServiceV2<SaleModel,
    SaleConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: SaleConverter) {
        super('Sale', http, httpUrlGenerator, logger, config, converter);
    }
}
